// src/config/seriesConfig.js

export const SERIES_STATE = {
    gt3x: {
        id: "gt3x",
        label: "GT3 Xperience",
        active: true,
    },
    specialx: {
        id: "specialx",
        label: "Special Xperience",
        active: true,
    },
    gtex: {
        id: "gtex",
        label: "GT Endu Xperience",
        active: false,
    },
    gt4x: {
        id: "gt4x",
        label: "GT4 Xperience",
        active: false,
    },
};
